import { useApi } from './use-api-call';

export const useSearchRegionApi = () =>
    useApi<{
        regions: RegionDTO[];
        allowEdit: boolean;
    }>('/region/search-region');

export const useGetRegionApi = () =>
    useApi<{ region: RegionDTO; allowEdit: boolean }>('/region/get-region/{id}');

export const useSaveRegionApi = () => useApi<{ region: RegionDTO }>('/region/save-region');

export const useDeleteRegionApi = () => useApi('/region/delete-region/{id}');

export interface RegionDTO {
    id: string;
    name: string;
    description: string;
}
